export default ({ gameCode, games, launchGame, showNotification }) => {
    let actionHandler;
    let failureReason;

    if (gameCode) {
        if (games[gameCode]) {
            actionHandler = () => launchGame(gameCode);
        } else {
            failureReason = 'Invalid gameCode';
            actionHandler = () => showNotification('playtech.mobile.system.toast.cannotLaunchGame', { variant: 'error' });
        }
    }

    return { actionHandler, failureReason };
};
